export default "__VITE_ASSET__CX1H3STD__"